import React from "react";
import { Chip, ChipOption, ChipSizeEnum } from "../Chip/Chip";
import { StyledContentTwoElementsChip } from "./InternalGradeChip.styled";
import { FontWeightEnum } from "../../../types/AppTypes";
import { BodyTyp } from "../../Typography/Typography";
import { theme } from "../../../constants/StyledComponents";

type TwoElementsChipProps = {
  value: string;
  number: number;
  color?: string;
  textMaxWidth?: number;
};

export const InternalGradeChip = ({
  value,
  number,
  color,
  textMaxWidth,
}: TwoElementsChipProps) => {
  const content: ChipOption<string> = {
    value: value,
    label: (
      <StyledContentTwoElementsChip>
        <BodyTyp
          fontWeight={FontWeightEnum.MEDIUM}
          variant="3"
          noLineHeight
          maxWidth={textMaxWidth}
        >
          {value}
        </BodyTyp>
        <BodyTyp fontWeight={FontWeightEnum.MEDIUM} variant="3" noLineHeight>
          {number}
        </BodyTyp>
      </StyledContentTwoElementsChip>
    ),
  };

  return (
    <Chip
      option={content}
      borderColor={color ?? theme.colors.green}
      size={ChipSizeEnum.REGULAR}
      fullWidth
      readonly
    />
  );
};
